import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ISiteSetting } from "../../types/api";
import TinyEditor from "../../components/Editor";
import { useFormContext } from "react-hook-form";

const ContentSettings = ({
    settings,
    settingsToShow,
    category,
}: {
    settings: ISiteSetting[];
    settingsToShow: string[];
    category: "content" | "rules";
}): React.JSX.Element | undefined => {
    const methods = useFormContext();

    return (
        <>
            {settings
                .filter(s => settingsToShow.includes(s.settingName))
                .map((s, idx) => {
                    const settingName = `${category}.${s.settingName}`;
                    const watchField = methods.watch(
                        settingName,
                        methods.getValues(settingName),
                    );

                    const [editorValue, setEditorValue] = useState<string>("");

                    useEffect(() => {
                        setEditorValue(s.setting);
                    }, [s.setting]);

                    return (
                        <Row key={idx} className="siteSettingsLeagueText">
                            <Col>
                                <h4>{s.displayTitle}</h4>
                                <Form.Control
                                    type="hidden"
                                    {...methods.register(settingName, {
                                        value: watchField
                                            ? "true"
                                            : methods.getValues(settingName) ||
                                              s.setting,
                                    })}
                                />
                                <TinyEditor
                                    editorValue={editorValue}
                                    showSave={false}
                                    formField={settingName}
                                    formMethods={methods}
                                    setEditorValue={setEditorValue}
                                />
                            </Col>
                        </Row>
                    );
                })}
        </>
    );
};

export default ContentSettings;
